import { render } from "./g-modal-container.vue?vue&type=template&id=e5f7eb02&ts=true"
import script from "./g-modal-container.vue?vue&type=script&lang=tsx"
export * from "./g-modal-container.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__